import { cva, type VariantProps } from '@/helpers/cva';

export const textVariants = cva({
  variants: {
    align: {
      center: 'text-center',
      end: 'text-end',
      justify: 'text-justify',
      start: 'text-start',
    },
    break: {
      true: '[overflow-wrap:anywhere] [word-break:normal]',
    },
    numeric: {
      true: 'lining-nums tabular-nums',
    },
    truncate: {
      true: 'truncate',
    },
    weight: {
      bold: 'font-bold',
      extrabold: 'font-extrabold',
      regular: 'font-normal',
      semibold: 'font-semibold',
    },
  },
});

export type TextVariants = VariantProps<typeof textVariants>
